const getDataDiff = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffInMilliseconds = Math.abs(startDate - endDate);
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
  if (diffInMilliseconds > oneDayInMilliseconds) {
    return diffInMilliseconds;
  } else {
    return 0;
  }
};

export default getDataDiff;
